/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Resource/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import CommsMobileNumbersInbound from './CommsMobileNumbersInbound/index'
import CommsMobileNumbersOutbound from './CommsMobileNumbersOutbound/index'
import No from './No/index'
import PublicUsers from './PublicUsers/index'
import React from 'react'
import VaxiomSysOrganizations from './VaxiomSysOrganizations/index'



/** @type {import('Simple/types.js').View} */
export default function Resource({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/MessageTools/External/Resources/Content/Resources/Content/Resource"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let threadResourceSchemaValueData = fromData.useDataValue({ viewPath,
context: 'thread_resource',
path: 'schema',
})
let threadResourceTableValueData = fromData.useDataValue({ viewPath,
context: 'thread_resource',
path: 'table',
})
let aggregateData = fromHelpers.getView(threadResourceSchemaValueData, threadResourceTableValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'VaxiomSysOrganizations'}>
<VaxiomSysOrganizations
  viewPath={`${viewPath}/VaxiomSysOrganizations`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PublicUsers'}>
<PublicUsers
  viewPath={`${viewPath}/PublicUsers`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CommsMobileNumbersInbound'}>
<CommsMobileNumbersInbound
  viewPath={`${viewPath}/CommsMobileNumbersInbound`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CommsMobileNumbersOutbound'}>
<CommsMobileNumbersOutbound
  viewPath={`${viewPath}/CommsMobileNumbersOutbound`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}